import { ILookupItems } from "../../Models/LookupItem";

export const LOAD_LIBRARY = 'LOAD_LIBRARY';
export const LOAD_LIBRARY_SUCCESS = 'LOAD_LIBRARY_SUCCESS';

/************************   Begin Library    ******************************/
// LOAD
export interface LoadLibrarysAction {
  type: typeof LOAD_LIBRARY;
  payload: { clientId?: string };
}
export const loadLibrary = (clientId?: string): LoadLibrarysAction => {
  return {
    type: LOAD_LIBRARY,
    payload: { clientId }
  };
}
export interface LoadLibrarysSuccessAction {
  type: typeof LOAD_LIBRARY_SUCCESS;
  payload: { lookupItems: ILookupItems };
}
export const loadLibrarysSuccess = (lookupItems: ILookupItems): LoadLibrarysSuccessAction => {
  return {
    type: LOAD_LIBRARY_SUCCESS,
    payload: { lookupItems }
  };
}
/************************   End Library    ******************************/
export type LibraryAction =
  LoadLibrarysAction
  | LoadLibrarysSuccessAction;
